import React, { useState } from 'react';
import { Row, Col, Button, Form, message } from 'antd';
import { validationService } from '../../services/validationPage';
import { handlers } from '../../helpers/helpers';
import { DocumentCard } from 'cmt-ui-kit';

const { format } = require('rut.js');

const Search = ({ setStep, refreshInitialTimeStamp, countryCode }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [documentType, setDocumentType] = useState(countryCode.toUpperCase() === 'CL' ? 'rut' : 'dni')
  const onFinish = async (values) => {
    try {
      setLoading(true);
      let documentNumber = '';
      if (documentType === 'rut') {
        documentNumber = format(values.documentNumber, { dots: false });
      } else {
        documentNumber = values.documentNumber
      }
      const responseList = await validationService.searchPatient({ documentNumber, documentType });
      const response = responseList !== null && responseList.length > 0 ? responseList[0] : responseList;
      response.tests = await validationService.patientTest({ documentNumber, documentType, countryCode: countryCode.toUpperCase() });

      if (response.document_number) {
        if (response.tests && response.tests.length > 0 && !response.tests.code) {
          handlers.handleUserData(response);
          setStep(2);
        } else {
          message.error({
            content: 'No hay test para este número de documento.',
            className: 'psychology-message',
            style: {
              marginTop: '40vh'
            }
          });
        }
      } else {
        message.error({
          content: 'Ocurrió un error. Inténtalo de nuevo.',
          className: 'psychology-message',
          style: {
            marginTop: '40vh'
          }
        });
      }
    } catch (err) {
      console.error(err);
      message.error({
        content: 'Ocurrió un error. Inténtalo de nuevo.',
        className: 'psychology-message',
        style: {
          marginTop: '40vh'
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTimeStamp = () => {
    refreshInitialTimeStamp();
  };

  return (
    <Row justify="center" className="search-container">
      <Col lg={22} md={22} className="mt-120">
        <Row justify="center">
          <Col md={24}>
            <h1 className="text-center mb-0">Te damos la bienvenida a CMT</h1>
            <h3 className="text-center mt-40">Ingresa el número de documento para comenzar</h3>
          </Col>
          <Col md={12} className="mt-30">
            <Form
              form={form}
              onFinish={onFinish}
              size="large"
              style={{ width: '100%' }}
              initialValues={{ documentType }}
            >
              <DocumentCard
                countryCode={countryCode.toUpperCase()}
                setDocumentType={setDocumentType}
                form={form}
                type='person'
              />
              <Row justify="center">
                <Col md={14} className="mt-30">
                  <Button loading={loading} onClick={handleTimeStamp} type="primary" htmlType="submit" block>Comenzar</Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Search;